import React from 'react';
import { FootNoteProps } from '../../../models/TopLevelTemplateComponentProps';
import FootnoteEditor from '../../FootnoteEditor';

/** Shared footnotes editor for every CMS block type. */
export default function BlockFootnotesEditor({
  footnotes,
  onChange,
}: {
  footnotes?: FootNoteProps[];
  onChange: (footnotes: FootNoteProps[]) => void;
}) {
  return <FootnoteEditor footnotes={footnotes ?? []} tone="tone1" onUpdate={onChange} />;
}
